import gql from 'graphql-tag';

export default gql`
	mutation GetOTP($ref: String!, $otp: String!) {
		getOtp(ref: $ref, otp: $otp) {
			available
		}
	}
`;
